import ParameterErrors from '../errors/ParameterErrors';
import HouseType from './HouseType';
import ParseError from '../errors/ParseError';
const {throwNotProvided, throwNotOfType}=ParameterErrors;
export default class HouseTypes{
	constructor(props){
		const{list } = props;
		this.getBySlug = this.getBySlug.bind(this);
		if(list===undefined||list===null)throwNotProvided('list');
		if(!Array.isArray(list))throwNotOfType('list', 'array');
		this._list = list;
	}
	getArray(){
		return this._list;
	}
	getBySlug(slug){
		for(var i=0; i<this._list.length; i++){
			const houseType = this._list[i];
			if(houseType.slug===slug)return houseType;
		}
		return null;
	}
	static fromJSON(jArrayHouseTypes, getSiteJson, configuration){
		const houseTypes=[];
		for(var i=0; i<jArrayHouseTypes.length; i++){
			const jObjectHouseType = jArrayHouseTypes[i];
			houseTypes.push(HouseType.fromJSON(jObjectHouseType, getSiteJson, configuration));
		}
		return new HouseTypes({
			list:houseTypes
		});
	}
	parse(value){
		if(value===undefined||value===null)throw new ParseError('value cannot be undefined or null');
		const valueNormalised = value.toLowerCase();
		for(var i=0; i<this._list.length; i++){
			const houseType = this._list[i];
			if(houseType.slug===value)
				return houseType;
			if(houseType.allPossibleLowerCaseStrings.indexOf(valueNormalised )>=0)
				return houseType;
		}
		throw new ParseError(`Could not parse "${value}" to HouseType`);
	}
}